import React, {useState, useEffect, useRef} from 'react';
import Input from '../../global/Input';
import {useTranslation} from 'react-i18next';
import {useForm} from 'react-hook-form';
import ImportForm from './ImportForm';
import {Splitter, SplitterPanel} from 'primereact/splitter';
import {classNames} from 'primereact/utils';
import GeoData from '../../../views/GeoData';
import {ImportPreview} from './ImportPreview';
import {permissions} from '../../../config/permissions';
import {checkPermission} from '../../../functions/functionLibrary';

type Props = {
    project: any
};
const ImportOverview = (props: Props): JSX.Element => {
    const {t} = useTranslation(['common']);
    const [importId, setImportId] = useState<number>(0);
    const [importHappened, setImportHappened] = useState<boolean>(false);

    const {
        control,
        formState: {errors},
        handleSubmit,
        getValues,
        reset
    } = useForm();


    const importOptions = [
        {
            name: 'alkisimport',
            label: t('importTag:alkisImport'),
            value: 1
        }, {
            name: 'personImport',
            label: t('importTag:personImport'),
            value: 2
        }, {
            name: 'measureImport',
            label: t('importTag:measureImport'),
            value: 3
        }, {
            name: 'inanspruchsnahmeImport',
            label: t('importTag:inanspruchsnahmeImport'),
            value: 4
        }, {
            name: 'appointmentsImport',
            label: t('importTag:appointmentsImport'),
            value: 5
        }

    ];

    const handleImportChanges = (value: boolean) => {
        // console.log('import state:', value)
        setImportHappened(value);
    };

    return (<div
        className={'scroll-card-main-content md:absolute overflow-auto'}
        style={{'top': '10px'}}>
        <Splitter stateKey={'splitterGlobalData'}
                  stateStorage={'local'}
                  className={'w-full h-full'}
                  gutterSize={4}
                  style={{border: 'none'}} onResizeEnd={() => {
            window.dispatchEvent(new Event('resize'));
        }}>
            <SplitterPanel
                className={classNames('h-full relative', 'col-6')}
                style={{minWidth: '320px'}}>
                <div className={'w-full text-center'}>

                    <div className="field">
                        <Input
                            type="dropdown" edit={checkPermission(permissions.editImportData)} name={'importlist'}
                            label={t('importTag:importChooser')}
                            dropdownOptions={importOptions}
                            validationControl={control}
                            onChange={(event) => {
                                console.log(event.value);
                                setImportId(event.value);
                                setImportHappened(false);
                            }}
                            // validationErrorMessage={getFormErrorMessage}
                            validationRules={{
                                required: false,
                                // required: t('globalData:persons.streetHouseNr') + ' ' + t('input:required')
                            }}
                        />
                    </div>
                    <div className="field">
                        <ImportForm name={'Import_' + importId} id={importId} project={props.project}
                                    importCallback={handleImportChanges}/>
                    </div>
                </div>
            </SplitterPanel>
            <SplitterPanel
                className={'relative overflow-hidden ml-2'}
                style={{borderRadius: '7px'}}>
                <ImportPreview project={props.project} importId={importId} importHappened={importHappened}/>
            </SplitterPanel>
        </Splitter>
    </div>);
};

export default ImportOverview;
